import { render, staticRenderFns } from "./migrationbungaharian.vue?vue&type=template&id=ccfaadcc&scoped=true&"
import script from "./migrationbungaharian.vue?vue&type=script&lang=js&"
export * from "./migrationbungaharian.vue?vue&type=script&lang=js&"
import style0 from "./migrationbungaharian.vue?vue&type=style&index=0&id=ccfaadcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfaadcc",
  null
  
)

export default component.exports